<template>
    <div class="popup popup--mini" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Завершить №{{ tenderId }}?</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <div class="popup__btns">
                    <button class="btn btn--color" @click="handleSubmit">Да</button>
                    <button class="btn btn--border" @click="$emit('close')">Нет</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {mapActions} from "vuex";
import {useToast} from "vue-toastification";

export default {
    name: 'CompleteTenderPopup',
    emits: ['close', 'updateTender'],
    props: {
        tenderId: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            toast: useToast(),
        }
    },

    methods: {
        async handleSubmit() {
            const res = await this.requesCompleteTender(this.tenderId);
            if (res.success) {
                this.toast.success(`Тендер успешно завершен`);
            }
            this.$emit('updateTender');
            this.$emit('close');
        },
        ...mapActions({
            requesCompleteTender: 'tenders/requesCompleteTender',
        })
    }
}
</script>
